import React from 'react';

const ProductOverview = ({ features, description, applications }) => {

    const overviewStyles = {
        general: {
            marginTop: "10px"
        },
        applicationGroup: {
            marginTop: "10px",
            marginBottom: "17px",
            marginLeft: "2px",
        },
        applications: {
            fontWeight: "600",
            color: "#333",
            marginBottom: "4px",
            marginTop: "12px",
            fontSize: "1rem",
            borderLeft: "2px solid #ccc",
            paddingLeft: "8px",
        },
    }

    return (
        <div>
            <h3 className="prod-header">Overview</h3>
            

            <div className="content-container">
        
                        <h5>Features: </h5>
                            <ul>
                                {features?
                                features.map((feature, idx) => (
                                <li key={idx} style={overviewStyles.general}>{feature[0]}
                                    {feature[1]?
                                    <ul>
                                        {feature[1].map((nestedFeature, idx) => (
                                            <li key={idx} style={overviewStyles.general}>{nestedFeature}</li>
                                        ))}
                                    </ul>
                                    :null}
                                </li>
                                ))
                                :null}
                            </ul>
                        <h5>Description: </h5>
                            {description?
                            description.map((aboutParagraph, idx) => (
                            <p key={idx} style={overviewStyles.general}>{aboutParagraph}</p>
                            ))
                            :null}
                            {applications.length?
                            <>
                        <h5>Applications: </h5>
                        <div>
                            {applications
                                ? applications.map((application, idx) => (
                                    <div key={idx} style={overviewStyles.applicationGroup}>

                                    {/* Group name */}
                                    <div style={overviewStyles.applications}>
                                        {application[0]}
                                    </div>

                                    {/* Applications as a joined string */}
                                    {application.length > 1 ? (
                                        <div style={{ fontSize: "0.9rem", color: "#555", marginTop: "2px" }}>
                                            {application
                                                .slice(1)                       // skip group title
                                                .map(app => (Array.isArray(app) ? app[0] : app))  
                                                .join(" · ")}                  
                                        </div>
                                    ) : null}
                                    </div>
                                ))
                            : null}
                        </div>
                            </>
                            :null}
            </div>
        </div>
    )
}

export default ProductOverview
